import store from './store'

type StoreAction = (payload?: unknown) => Promise<any>
type StoreActions = Record<string, StoreAction>

export function useActions(actions: Record<string, string>): StoreActions {
  const _actions: StoreActions = {}

  // todo: typization?
  Object.keys(actions).forEach((actionName: string) => {
    _actions[actionName] = (payload: any) => {
      return store.dispatch(actions[actionName], payload)
    }
  })

  return _actions
}
